export default __webpack_public_path__ + "static/media/main-banner.84746792.webp";